import { AuthSessionStore } from '@/services/auth/AuthSessionStore';
import { LocalStorageAdapter } from '@/services/storage/MemoryAdapter';
import { KeyValueStore } from '@/services/storage/StorageService';
import type { LocalStorageKey } from '@/services/storage/types';
import { AppLogger } from '@/services/log/log-service';
import type { ILogger } from '@/services/log/types';
import { AuthService } from '@/services/auth/auth-service';
import type { IAuthSessionStore, ITokenRefreshService } from '@/services/auth/types';
import type { IApiService } from '@/services/api/types';
import { ApiService } from '@/services/api/api-service';
import { TokenRefreshService } from '@/services/auth/token-refresh-service';

const logger = new AppLogger(import.meta.env.PROD ? 'warn' : 'trace');

const adapter = new LocalStorageAdapter();
const kv = new KeyValueStore<LocalStorageKey>('homevein', adapter, logger);
const sessionStore: IAuthSessionStore = new AuthSessionStore(kv, logger);
const authService = new AuthService(logger);
const tokenService: ITokenRefreshService = new TokenRefreshService({
  sessionStore,
  authService,
  logger,
});
const apiService: IApiService = new ApiService({
  sessionStore,
  tokenService,
  logger,
});

export interface DynamicConfig {
  sessionStore: IAuthSessionStore;
  logger: ILogger;
  authService: AuthService;
  apiService: IApiService;
  tokenService: ITokenRefreshService;
}

export const dynamicConfig: DynamicConfig = {
  sessionStore,
  logger,
  authService,
  apiService,
  tokenService,
};
